module.exports = __webpack_public_path__ + "static/assets/b5a0e0f3d690e6b62dca001e1d88df8d.svg";